import { useEffect, useRef } from "react";

import { LazyLoadComponent } from "react-lazy-load-image-component";

// variables de entorno
import { URL_IMAGE_GEOMEDELLIN } from "../../environment";

export const Player = ({
  id_ayuda,
  archivo,
  componente,
  classDivVideo,
  classVideo,
  handleClick,
}) => {
  const refVideo = useRef(null);

  const pauseOthersVideo = () => {
    try {
      handleClick();
    } catch (error) {
      console.error(error);
    }

    const othersVideos = document.getElementsByClassName(classVideo);

    for (const video of othersVideos) {
      video.pause();
      video.controls = false;
    }

    refVideo.current.controls = true;
  };

  return (
    <LazyLoadComponent>
      <div className={`${classDivVideo}`}>
        <video
          poster={"../icons/portadaVideo.jpg"}
          onClick={pauseOthersVideo}
          className={`${classVideo}`}
          muted
          loop
          controls={false}
          ref={refVideo}
        >
          <source
            src={`${URL_IMAGE_GEOMEDELLIN}/archivosGeomedellin/${componente?.nombre_componente}/${id_ayuda}/${archivo}`}
          ></source>
        </video>
      </div>
    </LazyLoadComponent>
  );
};
